'use client';

import dynamic from 'next/dynamic';
import type { ComponentProps } from 'react';

// `ssr: false` is only allowed inside Client Components, so the enquiry form is
// loaded from this wrapper instead of the server page.
const EnquiryForm = dynamic(() => import('@/components/EnquiryForm'), {
  ssr: false,
});

type EnquiryFormProps = ComponentProps<
  (typeof import('@/components/EnquiryForm'))['default']
>;

// `onCancel` is left out on purpose: functions cannot cross the server/client boundary.
type Props = Omit<EnquiryFormProps, 'onCancel'>;

export default function ExperienceEnquiryForm(props: Props) {
  return <EnquiryForm {...props} />;
}
